<template>
  <div class="container-symbol container-folders">
    <div
      class="content-folder-system"
      :class="{ 'bold-system': firstView }"
      v-if="viewSystemFolder"
    >
      <div class="title">{{ $t("folders.systemFiles") }}</div>
      <baseEmptyContent
        v-if="emptyFolderSystem"
        class
        :messages="messagesEmptySystem"
      />
      <div class="display-symbol">
        <modeViewFolder
          v-for="item in foldersSystem"
          :key="item.id"
          :item="item"
          systemFile="true"
          @click="selectFolder"
          @dblclick="openFolder"
          @edit-folder="editFolder"
          @addtempselect="addTempSelectArrow"
        />
      </div>
    </div>
    <div class="content-folder" v-if="viewMineFolder">
      <div class="title">{{ $t("folders.mineFiles") }}</div>
      <baseEmptyContent v-if="emptyFolder" class :messages="messagesEmpty" />
      <div class="display-symbol ">
        <div class="flex flex-wrap flex-cente">
          <createFolderView
            v-kiosk
            v-if="creatNewFolder === true"
            @input="createFolder"
            @edit-folder="editFolder"
          />
          <modeViewFolder
            v-kiosk="item.listable !== 'pdfbooks'"
            v-for="item in folders"
            :key="item.id"
            :item="item"
            systemFile="false"
            @click="selectFolder"
            @dblclick="openFolder"
            @addtempselect="addTempSelectArrow"
          />
        </div>
      </div>
    </div>
    <!-- in state of search -->
    <div class="content-folder-search" v-if="emptyFolderSearch">
      <div class="title">{{ $t("fsresults.header") }}</div>
      <baseEmptyContent
        v-if="emptyFolderSearch"
        class
        :messages="messagesEmptySearch"
      />
      <div class="display-symbol">
        <modeViewFolder
          v-for="item in listSearch.slice(0, endSearch)"
          :key="item.id"
          :item="item"
          :systemFile="item.systemFile"
          @click="selectFolder"
          @dblclick="openFolder"
          @addtempselect="addTempSelectArrow"
        />
      </div>
      <button
        v-if="listSearch.length > endSearch"
        class="center btn"
        @click="loadMoreResults"
      >
        {{ $t("general.loadMoreResults") }}
      </button>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixing/mixViewFolderContainerItems.js";
export default {
  mixins: [mixin],
  data() {
    return {
      // endSearch: 80,
      // addLoad: 40
    };
  },
  computed: {
    // listSearch() {
    //   if (this.getTextSearchInput || this.getTextSearchInput != "") {
    //     this.folders.forEach(element => (element.systemFile = "false"));
    //     this.foldersSystem.forEach(element => (element.systemFile = "true"));
    //     let findArray = [...this.folders, ...this.foldersSystem];
    //     return findArray;
    //   }
    //   return [];
    // }
  },
  methods: {
    // loadMoreResults() {
    //   if (this.listSearch.length > this.endSearch + this.addLoad)
    //     this.endSearch += 80;
    //   else this.endSearch = this.listSearch.length;
    // },
    addTempSelectArrow(item, elem, dir) {
      // return;
      if (dir == "left" || dir == "right") {
        this.addTempSelectArrowStepOne(item, elem);
        return;
      }
      this.m++;
      if (item) this.tempSelect.push({ item: item, el: elem });

      let c = 0;
      c += this.getAllListCurrent.length;
      // if (this.viewSystemFolder) c += this.foldersSystem.length;
      // if (this.hasViewMineFolder) c += this.folders.length;
      // because select component downt send event
      c--;
      if (this.m == c) {
        let s = this.getSelectFolder[0].positionElem.offsetTop;
        if (this.tempSelect.length == 0)
          this.tempSelect.push({
            item: this.folders[this.folders.length - 1],
            el: elem,
          });
        let a = this.tempSelect.map((x) => x.el.offsetTop - s);
        let abs = a.map(Math.abs);
        let i = abs.indexOf(Math.min(...abs));

        // this.selectedItem = this.tempSelect[i].item;
        this.$store.dispatch("folders/unSelectFolders");
        this.$store.dispatch("folders/setSelectFolder", {
          folder: this.tempSelect[i].item,
          foldersSystem: "",
          positionElem: this.tempSelect[i].el,
        });
        this.$store.dispatch("folders/arrowKey", { dir: "", isKey: false });
        this.m = 0;
        this.tempSelect = [];
      }
    },
    addTempSelectArrowStepOne(item, elem) {
      // return;
      this.$store.dispatch("folders/unSelectFolders");
      this.$store.dispatch("folders/setSelectFolder", {
        folder: item,
        foldersSystem: "",
        positionElem: elem,
      });
      this.$store.dispatch("folders/arrowKey", { dir: "", isKey: false });
    },
  },
};
</script>
<style lang="scss" scoped>
.content-folder {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
